import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getSubscription, getSubscriptions, postSubscription, deleteSubscription, deleteSubscriptionByResourceType, createSubscriptionUpdatePlan } from './client/subscriptions';
import { isSubscriptionEqual, areResourceFiltersEqual } from './utils';
import { MISSING_AUTH } from './common';
export { MISSING_AUTH };

const withSubscriptionsManagement = WrappedComponent => {
  class SubscriptionsManagementHOC extends Component {
    static propTypes = {
      environment: PropTypes.oneOf(['int', 'prd']),
      accessToken: PropTypes.string,
    };

    static defaultProps = {
      environment: 'int',
    };

    createSubscriptionUpdatePlan = ({ subscriptionsBefore = [], subscriptionsAfter = [] }, options) => {
      const subscriptionsToAdd = subscriptionsAfter.filter(
        after => !subscriptionsBefore.some(before => isSubscriptionEqual(before, after, options))
      );
      const subscriptionsToDelete = subscriptionsBefore.filter(
        before => !subscriptionsAfter.some(after => isSubscriptionEqual(before, after, options))
      );
      return { subscriptionsToAdd, subscriptionsToDelete };
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          isSubscriptionEqual={isSubscriptionEqual}
          areResourceFiltersEqual={areResourceFiltersEqual}
          getSubscription={(id) => getSubscription(id, this.props.accessToken, this.props.environment )}
          getSubscriptions={({resourceId, resourceType, filter }) => getSubscriptions({resourceId, resourceType, filter }, this.props.accessToken, this.props.environment)}
          postSubscription={(subscription) => postSubscription(subscription, this.props.accessToken, this.props.environment)}
          deleteSubscription={(id) => deleteSubscription(id,this.props.accessToken, this.props.environment)}
          deleteSubscriptionByResourceType={(resourceType) => deleteSubscriptionByResourceType(resourceType, this.props.accessToken, this.props.environment)}
          createSubscriptionUpdatePlan={this.createSubscriptionUpdatePlan}
        />
      );
    }
  }

  return SubscriptionsManagementHOC;
};

export default withSubscriptionsManagement;
